module.exports = __webpack_public_path__ + "static/media/notifications-image.6e762bac.svg";